import { t } from "@lingui/core/macro";
import { RegrelloSpinner } from "@regrello/ui-core";

export function Verifying() {
  return (
    <div className="flex flex-col items-center justify-center mt-10 gap-10">
      <h1 className="flex items-center text-4xl md:text-5xl">{t`Verifying`}</h1>
      <p className="text-base">{t`We’re verifying your account. This should only take a moment.`}</p>
      <RegrelloSpinner />
    </div>
  );
}
